import React, { useState } from 'react';

const EventosPage: React.FC = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isDjProjecteModalOpen, setIsDjProjecteModalOpen] = useState(false);
  const [isSonorizacionModalOpen, setIsSonorizacionModalOpen] = useState(false);
  const [isDiscomovilModalOpen, setIsDiscomovilModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);
    
    // Validate textarea character limit
    const mensaje = formData.get('mensaje') as string;
    if (mensaje && mensaje.length > 500) {
      alert('El mensaje no puede exceder 500 caracteres');
      setIsSubmitting(false);
      return;
    }

    // Convert FormData to URL-encoded format
    const urlEncodedData = new URLSearchParams();
    for (const [key, value] of formData.entries()) {
      urlEncodedData.append(key, value.toString());
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d4tdvq6u005hmhpl87o0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: urlEncodedData.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        form.reset();
        setTimeout(() => {
          setIsFormOpen(false);
          setSubmitStatus('idle');
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    }
    
    setIsSubmitting(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-slate-800 to-slate-700">
      {/* Navigation */}
      <nav className="bg-black/80 backdrop-blur-md border-b-2 border-gradient-to-r from-yellow-400 via-orange-500 to-yellow-400">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center space-x-3 ml-0">
              <div className="bg-black/20 backdrop-blur-sm rounded-xl p-1 border border-yellow-400/30">
                <img 
                  src="https://static.readdy.ai/image/f83f5cd629da4d80734129e80e4e4145/4a7f8b54088d811b1f1eaf12115718e6.jpeg" 
                  alt="ESPECTÁCULOS BRONCHÚ Logo" 
                  className="h-14 w-14 rounded-lg shadow-lg object-cover"
                />
              </div>
              <div>
                <h1 className="text-xl font-black text-white font-sans tracking-widest drop-shadow-2xl" style={{fontFamily: 'Inter, system-ui, sans-serif', letterSpacing: '0.2em', textShadow: '2px 2px 4px rgba(0,0,0,0.8)'}}>
                  ESPECTÁCULOS BRONCHÚ
                </h1>
                <p className="text-xs text-yellow-400 font-light tracking-widest" style={{letterSpacing: '0.25em'}}>
                  L'ART DEL FOC I EL SO
                </p>
              </div>
            </div>

            {/* Navigation Menu */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="/" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                INICIO
              </a>
              <a href="/pirotecnica" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                PIROTECNIA
              </a>
              <a href="/eventos" className="text-yellow-400 border-b-2 border-yellow-400 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                EVENTOS
              </a>
              <a href="/videos" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                VIDEOS
              </a>
              <a href="/calendario" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                CALENDARIO
              </a>
              <a href="/merchandising" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                MERCHANDISING
              </a>
              <a href="/nosotros" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                NOSOTROS
              </a>
              <a href="/contacto" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                CONTACTO
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative py-20 sm:py-32">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=professional%20sound%20system%20and%20DJ%20equipment%20setup%2C%20concert%20venue%20with%20colorful%20lights%2C%20people%20dancing%2C%20party%20atmosphere%2C%20mobile%20disco%2C%20entertainment%20event%2C%20professional%20audio%20equipment&width=1920&height=800&seq=28&orientation=landscape')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-gray-900/50 via-gray-900/30 to-gray-900/50"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 text-center">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 sm:mb-6 tracking-wider drop-shadow-2xl px-2">
            SONIDO Y
            <span className="block text-5xl sm:text-6xl md:text-7xl lg:text-8xl bg-gradient-to-r from-cyan-400 via-purple-400 to-pink-400 bg-clip-text text-transparent font-black tracking-widest drop-shadow-2xl" style={{textShadow: '0 0 30px rgba(34, 211, 238, 0.8), 0 0 60px rgba(168, 85, 247, 0.6)'}}>
              ENTRETENIMIENTO
            </span>
          </h1>
          
          <p className="text-lg sm:text-xl md:text-2xl text-cyan-400 mb-8 sm:mb-12 font-serif tracking-wider px-4">
            EQUIPOS PROFESIONALES
          </p>
          
          <p className="text-base sm:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed mb-8 px-4">
            17 años creando la banda sonora perfecta
          </p>
          
          <button 
            onClick={() => setIsFormOpen(true)}
            className="bg-gradient-to-r from-cyan-500 to-purple-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-bold text-base sm:text-lg tracking-wider hover:scale-105 transition-transform duration-300 flex items-center space-x-2 mx-auto cursor-pointer whitespace-nowrap"
          >
            <i className="ri-music-line text-lg sm:text-xl"></i>
            <span className="hidden sm:inline">SOLICITAR PRESUPUESTO</span>
            <span className="sm:hidden">PRESUPUESTO</span>
          </button>
        </div>
      </section>

      {/* Servicios de Sonido */}
      <section className="py-20 bg-gradient-to-b from-slate-700 to-slate-600">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {/* Sonorización de Eventos */}
            <div className="md:col-span-1">
              <div 
                className="h-96 bg-cover bg-center rounded-2xl overflow-hidden relative border-2 border-cyan-400"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=professional%20sound%20system%20equipment%20setup%2C%20large%20speakers%20and%20audio%20mixing%20console%2C%20concert%20venue%2C%20professional%20sound%20engineering%2C%20stage%20lighting%2C%20high-tech%20audio%20equipment&width=300&height=384&seq=29&orientation=portrait')`
                }}
              >
                <div className="absolute inset-0 bg-black/50"></div>
                <div className="absolute top-4 left-4">
                  <div className="bg-cyan-400 w-12 h-12 rounded-full flex items-center justify-center">
                    <i className="ri-sound-module-line text-black text-xl"></i>
                  </div>
                </div>
                <div className="absolute bottom-6 left-6 right-6">
                  <h3 className="text-white text-lg font-bold tracking-wider mb-2">
                    SONORIZACIÓN DE EVENTOS
                  </h3>
                  <p className="text-gray-300 text-sm mb-4">
                    EQUIPOS PROFESIONALES DE ALTA CALIDAD
                  </p>
                  <button 
                    onClick={() => setIsSonorizacionModalOpen(true)}
                    className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 text-white py-2 rounded-lg font-semibold text-sm hover:scale-105 transition-transform duration-300 cursor-pointer whitespace-nowrap"
                  >
                    CONOCER MÁS
                  </button>
                </div>
              </div>
            </div>

            {/* Discomóviles */}
            <div className="md:col-span-2">
              <div 
                className="h-96 bg-cover bg-center rounded-2xl overflow-hidden relative"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=mobile%20disco%20DJ%20in%20action%2C%20colorful%20party%20lights%2C%20people%20dancing%2C%20vibrant%20dance%20floor%2C%20DJ%20mixing%20music%2C%20party%20atmosphere%2C%20disco%20lights%20effects%2C%20nightclub%20ambiance&width=600&height=384&seq=30&orientation=landscape')`
                }}
              >
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-purple-500/20 to-cyan-400/20"></div>
                <div className="absolute top-4 right-4">
                  <span className="bg-gradient-to-r from-pink-500 to-purple-600 text-white px-4 py-2 rounded-full text-sm font-bold">
                    POPULAR
                  </span>
                </div>
                <div className="absolute bottom-1/2 left-1/2 transform -translate-x-1/2 translate-y-1/2">
                  <h3 className="text-white text-4xl font-bold tracking-wider text-center mb-6" style={{textShadow: '0 0 15px #FF00FF, 0 0 30px #00FFFF'}}>
                    DISCOMÓVILES
                  </h3>
                  <button 
                    onClick={() => setIsDiscomovilModalOpen(true)}
                    className="bg-gradient-to-r from-purple-500 to-pink-600 text-white px-6 py-3 rounded-lg font-semibold text-sm hover:scale-105 transition-transform duration-300 cursor-pointer whitespace-nowrap mx-auto block"
                  >
                    CONOCER MÁS
                  </button>
                </div>
              </div>
            </div>

            {/* DJPROJECTE */}
            <div className="md:col-span-1">
              <div 
                className="h-96 bg-cover bg-center rounded-2xl overflow-hidden relative"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=modern%20DJ%20setup%20with%20professional%20equipment%2C%20futuristic%20lighting%2C%20tech%20atmosphere%2C%20electronic%20music%20environment%2C%20high-end%20DJ%20controller%2C%20neon%20lighting%20effects&width=300&height=384&seq=31&orientation=portrait')`
                }}
              >
                <div className="absolute inset-0 bg-black/60"></div>
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-cyan-500/10 to-purple-500/20"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                  <h3 className="text-white text-2xl font-bold tracking-wider text-center font-mono">
                    DJ<br />PROJECTE
                  </h3>
                </div>
                <div className="absolute bottom-6 left-6 right-6">
                  <button 
                    onClick={() => setIsDjProjecteModalOpen(true)}
                    className="w-full bg-gradient-to-r from-cyan-500 to-purple-600 text-white py-2 rounded-lg font-semibold text-sm hover:scale-105 transition-transform duration-300 cursor-pointer whitespace-nowrap"
                  >
                    CONOCER MÁS
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Detalles de Servicios */}
      <section className="py-20 bg-gradient-to-b from-slate-600 to-gray-700">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-5xl font-serif font-bold text-center text-white mb-16 tracking-wider">
            NUESTROS SERVICIOS DE <span className="bg-gradient-to-r from-cyan-400 via-purple-400 to-pink-400 bg-clip-text text-transparent font-black text-6xl">ENTRETENIMIENTO</span>
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            {/* Sonorización Profesional */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-cyan-400/30 hover:border-cyan-400 transition-colors duration-300">
              <div className="bg-cyan-400 w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-sound-module-line text-black text-2xl"></i>
              </div>
              <h3 className="text-white text-2xl font-bold text-center mb-4 tracking-wider">
                SONORIZACIÓN PROFESIONAL
              </h3>
              <ul className="text-gray-300 space-y-3">
                <li className="flex items-center">
                  <i className="ri-check-line text-cyan-400 mr-3"></i>
                  Equipos de alta gama
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-cyan-400 mr-3"></i>
                  Técnicos especializados
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-cyan-400 mr-3"></i>
                  Montaje y desmontaje incluido
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-cyan-400 mr-3"></i>
                  Cobertura total del evento
                </li>
              </ul>
            </div>

            {/* Discomóvil */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-purple-400/30 hover:border-purple-400 transition-colors duration-300">
              <div className="bg-gradient-to-r from-purple-500 to-pink-500 w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-music-2-line text-white text-2xl"></i>
              </div>
              <h3 className="text-white text-2xl font-bold text-center mb-4 tracking-wider">
                DISCOMÓVIL
              </h3>
              <ul className="text-gray-300 space-y-3">
                <li className="flex items-center">
                  <i className="ri-check-line text-purple-400 mr-3"></i>
                  DJ profesional incluido
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-purple-400 mr-3"></i>
                  Iluminación espectacular
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-purple-400 mr-3"></i>
                  Música para todas las edades
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-purple-400 mr-3"></i>
                  Animación personalizada
                </li>
              </ul>
            </div>

            {/* DJ Projecte */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-yellow-400/30 hover:border-yellow-400 transition-colors duration-300">
              <div className="bg-yellow-400 w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-disc-line text-black text-2xl"></i>
              </div>
              <h3 className="text-white text-2xl font-bold text-center mb-4 tracking-wider font-mono">
                DJ PROJECTE
              </h3>
              <ul className="text-gray-300 space-y-3">
                <li className="flex items-center">
                  <i className="ri-check-line text-yellow-400 mr-3"></i>
                  Alquiler de equipos
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-yellow-400 mr-3"></i>
                  Crecimiento progresivo
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-yellow-400 mr-3"></i>
                  Asesoramiento técnico
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-yellow-400 mr-3"></i>
                  Precios competitivos
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Tipos de Eventos */}
      <section className="py-20 bg-gradient-to-b from-gray-700 to-slate-700">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-serif font-bold text-white mb-6 tracking-wider">
              EVENTOS QUE CUBRIMOS
            </h2>
            <p className="text-xl text-gray-300">
              Experiencia en todo tipo de celebraciones y eventos
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div 
              className="h-64 bg-cover bg-center rounded-2xl relative group cursor-pointer hover:scale-105 transition-transform duration-300"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=elegant%20wedding%20reception%20with%20professional%20sound%20system%2C%20bride%20and%20groom%20dancing%2C%20romantic%20lighting%2C%20wedding%20party%20celebration%2C%20professional%20DJ%20equipment&width=300&height=256&seq=32&orientation=portrait')`
              }}
            >
              <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-all duration-300 rounded-2xl"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <h3 className="text-white text-xl font-bold tracking-wider">BODAS</h3>
                <p className="text-gray-200 text-sm">Música perfecta para tu día especial</p>
              </div>
            </div>

            <div 
              className="h-64 bg-cover bg-center rounded-2xl relative group cursor-pointer hover:scale-105 transition-transform duration-300"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=corporate%20business%20event%20with%20professional%20sound%20system%2C%20business%20people%20networking%2C%20elegant%20venue%2C%20professional%20lighting%2C%20corporate%20party%20atmosphere&width=300&height=256&seq=33&orientation=portrait')`
              }}
            >
              <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-all duration-300 rounded-2xl"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <h3 className="text-white text-xl font-bold tracking-wider">CORPORATIVOS</h3>
                <p className="text-gray-200 text-sm">Profesionalidad en cada detalle</p>
              </div>
            </div>

            <div 
              className="h-64 bg-cover bg-center rounded-2xl relative group cursor-pointer hover:scale-105 transition-transform duration-300"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=birthday%20party%20celebration%20with%20disco%20lights%2C%20people%20celebrating%2C%20party%20atmosphere%2C%20colorful%20decorations%2C%20fun%20celebration%20with%20DJ%20setup&width=300&height=256&seq=34&orientation=portrait')`
              }}
            >
              <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-all duration-300 rounded-2xl"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <h3 className="text-white text-xl font-bold tracking-wider">CUMPLEAÑOS</h3>
                <p className="text-gray-200 text-sm">Diversión garantizada</p>
              </div>
            </div>

            <div 
              className="h-64 bg-cover bg-center rounded-2xl relative group cursor-pointer hover:scale-105 transition-transform duration-300"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=graduation%20party%20with%20young%20people%20dancing%2C%20disco%20lights%2C%20celebration%20atmosphere%2C%20students%20celebrating%2C%20party%20music%20and%20entertainment&width=300&height=256&seq=35&orientation=portrait')`
              }}
            >
              <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-all duration-300 rounded-2xl"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <h3 className="text-white text-xl font-bold tracking-wider">GRADUACIONES</h3>
                <p className="text-gray-200 text-sm">Celebra tus logros</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-t from-slate-800 to-gray-700 py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center">
            <h3 className="text-white text-2xl font-serif font-bold mb-4">
              ¿NECESITAS SONORIZACIÓN PARA TU EVENTO?
            </h3>
            <p className="text-gray-300 mb-8">
              Contacta con nosotros y haremos que tu evento sea inolvidable
            </p>
            <div className="flex justify-center">
              <button 
                onClick={() => setIsFormOpen(true)}
                className="bg-gradient-to-r from-cyan-500 to-purple-600 text-white px-8 py-4 rounded-lg font-bold text-lg tracking-wider hover:scale-105 transition-transform duration-300 cursor-pointer whitespace-nowrap"
              >
                SOLICITAR PRESUPUESTO
              </button>
            </div>
          </div>
          
          {/* Copyright */}
          <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col lg:flex-row items-center justify-between">
            <p className="text-gray-400 text-sm mb-4 lg:mb-0">
              © 2025 ESPECTÁCULOS BRONCHÚ. TODOS LOS DERECHOS RESERVADOS.
            </p>
            
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 text-sm hover:text-yellow-400 transition-colors duration-300 cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>

      {/* Form Modal */}
      {isFormOpen && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto border border-cyan-400/30">
            <div className="p-8">
              {/* Header */}
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-3xl font-bold text-white tracking-wider">
                  SOLICITAR PRESUPUESTO
                </h2>
                <button
                  onClick={() => setIsFormOpen(false)}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>

              {/* Form */}
              <form id="presupuesto-form" data-readdy-form onSubmit={handleFormSubmit} className="space-y-6">
                {/* Personal Info */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="nombre" className="block text-cyan-400 font-semibold mb-2 text-sm">
                      NOMBRE COMPLETO *
                    </label>
                    <input
                      type="text"
                      id="nombre"
                      name="nombre"
                      required
                      className="w-full bg-slate-700/50 border border-slate-600 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-cyan-400 transition-colors"
                      placeholder="Tu nombre completo"
                    />
                  </div>
                  <div>
                    <label htmlFor="telefono" className="block text-cyan-400 font-semibold mb-2 text-sm">
                      TELÉFONO *
                    </label>
                    <input
                      type="tel"
                      id="telefono"
                      name="telefono"
                      required
                      className="w-full bg-slate-700/50 border border-slate-600 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-cyan-400 transition-colors"
                      placeholder="693 812 675"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="email" className="block text-cyan-400 font-semibold mb-2 text-sm">
                    EMAIL *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full bg-slate-700/50 border border-slate-600 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-cyan-400 transition-colors"
                    placeholder="tu@email.com"
                  />
                </div>

                {/* Event Details */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="tipo_evento" className="block text-cyan-400 font-semibold mb-2 text-sm">
                      TIPO DE EVENTO *
                    </label>
                    <select
                      id="tipo_evento"
                      name="tipo_evento"
                      required
                      className="w-full bg-slate-700/50 border border-slate-600 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-cyan-400 transition-colors"
                    >
                      <option value="">Selecciona el tipo de evento</option>
                      <option value="boda">Boda</option>
                      <option value="cumpleanos">Cumpleaños</option>
                      <option value="corporativo">Evento Corporativo</option>
                      <option value="graduacion">Graduación</option>
                      <option value="fiesta_privada">Fiesta Privada</option>
                      <option value="comunion">Comunión</option>
                      <option value="otro">Otro</option>
                    </select>
                  </div>
                  <div>
                    <label htmlFor="fecha_evento" className="block text-cyan-400 font-semibold mb-2 text-sm">
                      FECHA DEL EVENTO *
                    </label>
                    <input
                      type="date"
                      id="fecha_evento"
                      name="fecha_evento"
                      required
                      className="w-full bg-slate-700/50 border border-slate-600 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-cyan-400 transition-colors"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="ubicacion" className="block text-cyan-400 font-semibold mb-2 text-sm">
                      UBICACIÓN *
                    </label>
                    <input
                      type="text"
                      id="ubicacion"
                      name="ubicacion"
                      required
                      className="w-full bg-slate-700/50 border border-slate-600 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-cyan-400 transition-colors"
                      placeholder="Ciudad o dirección del evento"
                    />
                  </div>
                  <div>
                    <label htmlFor="invitados" className="block text-cyan-400 font-semibold mb-2 text-sm">
                      Nº INVITADOS APROX.
                    </label>
                    <select
                      id="invitados"
                      name="invitados"
                      className="w-full bg-slate-700/50 border border-slate-600 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-cyan-400 transition-colors"
                    >
                      <option value="">Selecciona número aprox.</option>
                      <option value="1-50">1-50 personas</option>
                      <option value="51-100">51-100 personas</option>
                      <option value="101-200">101-200 personas</option>
                      <option value="201-300">201-300 personas</option>
                      <option value="300+">Más de 300 personas</option>
                    </select>
                  </div>
                </div>

                {/* Services */}
                <div>
                  <label className="block text-cyan-400 font-semibold mb-3 text-sm">
                    SERVICIOS REQUERIDOS *
                  </label>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <label className="flex items-center space-x-3 cursor-pointer">
                      <input
                        type="checkbox"
                        name="servicios"
                        value="sonorizacion"
                        className="w-4 h-4 text-cyan-400 bg-slate-700 border-slate-600 rounded focus:ring-cyan-400 focus:ring-2"
                      />
                      <span className="text-white text-sm">Sonorización profesional</span>
                    </label>
                    <label className="flex items-center space-x-3 cursor-pointer">
                      <input
                        type="checkbox"
                        name="servicios"
                        value="discomovil"
                        className="w-4 h-4 text-cyan-400 bg-slate-700 border-slate-600 rounded focus:ring-cyan-400 focus:ring-2"
                      />
                      <span className="text-white text-sm">Discomóvil</span>
                    </label>
                    <label className="flex items-center space-x-3 cursor-pointer">
                      <input
                        type="checkbox"
                        name="servicios"
                        value="dj_projecte"
                        className="w-4 h-4 text-cyan-400 bg-slate-700 border-slate-600 rounded focus:ring-cyan-400 focus:ring-2"
                      />
                      <span className="text-white text-sm">DJ Projecte (alquiler equipos)</span>
                    </label>
                    <label className="flex items-center space-x-3 cursor-pointer">
                      <input
                        type="checkbox"
                        name="servicios"
                        value="iluminacion"
                        className="w-4 h-4 text-cyan-400 bg-slate-700 border-slate-600 rounded focus:ring-cyan-400 focus:ring-2"
                      />
                      <span className="text-white text-sm">Iluminación especializada</span>
                    </label>
                  </div>
                </div>

                {/* Message */}
                <div>
                  <label htmlFor="mensaje" className="block text-cyan-400 font-semibold mb-2 text-sm">
                    DETALLES ADICIONALES
                  </label>
                  <textarea
                    id="mensaje"
                    name="mensaje"
                    rows={4}
                    maxLength={500}
                    className="w-full bg-slate-700/50 border border-slate-600 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-cyan-400 transition-colors resize-none"
                    placeholder="Cuéntanos más detalles sobre tu evento... (máximo 500 caracteres)"
                  ></textarea>
                  <p className="text-xs text-gray-400 mt-1">Máximo 500 caracteres</p>
                </div>

                {/* Submit Status */}
                {submitStatus === 'success' && (
                  <div className="bg-green-500/20 border border-green-500 rounded-lg p-4 text-green-400 text-center">
                    <i className="ri-check-line text-xl mr-2"></i>
                    ¡Presupuesto enviado correctamente! Te contactaremos pronto.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="bg-red-500/20 border border-red-500 rounded-lg p-4 text-red-400 text-center">
                    <i className="ri-error-warning-line text-xl mr-2"></i>
                    Error al enviar el presupuesto. Por favor, inténtalo de nuevo.
                  </div>
                )}

                {/* Submit Button */}
                <div className="flex flex-col sm:flex-row gap-4 pt-4">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="flex-1 bg-gradient-to-r from-cyan-500 to-purple-600 text-white px-6 py-3 rounded-lg font-bold text-sm tracking-wider hover:scale-105 transition-transform duration-300 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
                  >
                    {isSubmitting ? (
                      <>
                        <i className="ri-loader-4-line animate-spin mr-2"></i>
                        ENVIANDO...
                      </>
                    ) : (
                      <>
                        <i className="ri-send-plane-line mr-2"></i>
                        SOLICITAR PRESUPUESTO
                      </>
                    )}
                  </button>
                  <button
                    type="button"
                    onClick={() => setIsFormOpen(false)}
                    className="px-6 py-3 border border-gray-500 text-gray-400 rounded-lg font-bold text-sm tracking-wider hover:border-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                  >
                    CANCELAR
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Sonorización Modal */}
      {isSonorizacionModalOpen && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl max-w-5xl w-full max-h-[90vh] overflow-y-auto border border-cyan-400/30">
            <div className="p-8">
              {/* Header */}
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h2 className="text-4xl font-bold text-white tracking-wider mb-2">
                    SONORIZACIÓN DE EVENTOS
                  </h2>
                  <p className="text-cyan-400 text-lg font-semibold">
                    EQUIPOS PROFESIONALES PARA TODO TIPO DE EVENTOS
                  </p>
                </div>
                <button
                  onClick={() => setIsSonorizacionModalOpen(false)}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>

              {/* Tipos de Montajes */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
                {/* Montaje Básico */}
                <div className="bg-slate-700/50 rounded-xl p-6 border border-cyan-400/20">
                  <div className="flex items-center mb-4">
                    <div className="bg-cyan-400 w-12 h-12 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-volume-up-line text-black text-xl"></i>
                    </div>
                    <h3 className="text-white text-xl font-bold">MONTAJE BÁSICO</h3>
                  </div>
                  <p className="text-gray-300 mb-4">
                    Ideal para eventos pequeños e íntimos hasta 100 personas.
                  </p>
                  <ul className="space-y-2 text-gray-300 text-sm">
                    <li className="flex items-center">
                      <i className="ri-check-line text-cyan-400 mr-2"></i>
                      2 altavoces activos de 12"
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-cyan-400 mr-2"></i>
                      Mesa de mezclas 4 canales
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-cyan-400 mr-2"></i>
                      2 micrófonos inalámbricos
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-cyan-400 mr-2"></i>
                      Conexiones para móvil/PC
                    </li>
                  </ul>
                </div>

                {/* Montaje Profesional */}
                <div className="bg-slate-700/50 rounded-xl p-6 border border-yellow-400/20">
                  <div className="flex items-center mb-4">
                    <div className="bg-yellow-400 w-12 h-12 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-sound-module-line text-black text-xl"></i>
                    </div>
                    <h3 className="text-white text-xl font-bold">MONTAJE PROFESIONAL</h3>
                  </div>
                  <p className="text-gray-300 mb-4">
                    Para eventos medianos y grandes hasta 300 personas.
                  </p>
                  <ul className="space-y-2 text-gray-300 text-sm">
                    <li className="flex items-center">
                      <i className="ri-check-line text-yellow-400 mr-2"></i>
                      Sistema de sonido profesional
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-yellow-400 mr-2"></i>
                      Subwoofers de 18"
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-yellow-400 mr-2"></i>
                      Mesa digital 24 canales
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-yellow-400 mr-2"></i>
                      4 micrófonos inalámbricos
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-yellow-400 mr-2"></i>
                      Técnico de sonido incluido
                    </li>
                  </ul>
                </div>

                {/* Montaje Premium */}
                <div className="bg-slate-700/50 rounded-xl p-6 border border-purple-400/20">
                  <div className="flex items-center mb-4">
                    <div className="bg-purple-400 w-12 h-12 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-music-line text-white text-xl"></i>
                    </div>
                    <h3 className="text-white text-xl font-bold">MONTAJE PREMIUM</h3>
                  </div>
                  <p className="text-gray-300 mb-4">
                    Para grandes eventos corporativos y festivales.
                  </p>
                  <ul className="space-y-2 text-gray-300 text-sm">
                    <li className="flex items-center">
                      <i className="ri-check-line text-purple-400 mr-2"></i>
                      Sistema de gran formato
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-purple-400 mr-2"></i>
                      Múltiples zonas de audio
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-purple-400 mr-2"></i>
                      Mesa digital profesional
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-purple-400 mr-2"></i>
                      Equipo técnico completo
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-purple-400 mr-2"></i>
                      Monitorización en tiempo real
                    </li>
                  </ul>
                </div>

                {/* Servicios Adicionales */}
                <div className="bg-slate-700/50 rounded-xl p-6 border border-green-400/20">
                  <div className="flex items-center mb-4">
                    <div className="bg-green-400 w-12 h-12 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-add-line text-black text-xl"></i>
                    </div>
                    <h3 className="text-white text-xl font-bold">SERVICIOS ADICIONALES</h3>
                  </div>
                  <p className="text-gray-300 mb-4">
                    Complementa tu evento con servicios extra.
                  </p>
                  <ul className="space-y-2 text-gray-300 text-sm">
                    <li className="flex items-center">
                      <i className="ri-check-line text-green-400 mr-2"></i>
                      Efectos de fuego frío
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-green-400 mr-2"></i>
                      Iluminación de ambiente
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-green-400 mr-2"></i>
                      Pantallas LED
                    </li>
                  </ul>
                </div>
              </div>

              {/* Imagen y Descripción */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
                <div 
                  className="h-64 bg-cover bg-center rounded-xl"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=professional%20sound%20engineer%20working%20with%20large%20mixing%20console%2C%20concert%20venue%20setup%2C%20professional%20audio%20equipment%2C%20stage%20monitors%2C%20line%20array%20speakers%2C%20technical%20crew%20working&width=500&height=300&seq=54&orientation=landscape')`
                  }}
                >
                  <div className="h-full bg-gradient-to-t from-black/60 to-transparent rounded-xl flex items-end">
                    <div className="p-6">
                      <p className="text-white font-semibold text-lg">
                        "Sonido perfecto para cada momento"
                      </p>
                    </div>
                  </div>
                </div>

                <div>
                  <h3 className="text-white text-2xl font-bold mb-4">
                    ¿POR QUÉ ELEGIRNOS?
                  </h3>
                  <div className="space-y-4">
                    <div className="flex items-start space-x-3">
                      <i className="ri-shield-check-line text-cyan-400 text-xl mt-1"></i>
                      <div>
                        <h4 className="text-white font-semibold">EXPERIENCIA GARANTIZADA</h4>
                        <p className="text-gray-300 text-sm">Más de 25 años en sonorización profesional</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <i className="ri-tools-line text-cyan-400 text-xl mt-1"></i>
                      <div>
                        <h4 className="text-white font-semibold">EQUIPOS DE ÚLTIMA GENERACIÓN</h4>
                        <p className="text-gray-300 text-sm">Renovamos nuestro equipamiento continuamente</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <i className="ri-customer-service-2-line text-cyan-400 text-xl mt-1"></i>
                      <div>
                        <h4 className="text-white font-semibold">SOPORTE TÉCNICO 24/7</h4>
                        <p className="text-gray-300 text-sm">Técnicos especializados en cada evento</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Botones de Acción */}
              <div className="flex flex-col sm:flex-row gap-4 pt-8 border-t border-slate-600">
                <button
                  onClick={() => {
                    setIsSonorizacionModalOpen(false);
                    setIsFormOpen(true);
                  }}
                  className="flex-1 bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-6 py-3 rounded-lg font-bold text-sm tracking-wider hover:scale-105 transition-transform duration-300 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-calendar-line mr-2"></i>
                  SOLICITAR PRESUPUESTO
                </button>
                <button
                  onClick={() => setIsSonorizacionModalOpen(false)}
                  className="px-6 py-3 border border-gray-500 text-gray-400 rounded-lg font-bold text-sm tracking-wider hover:border-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  CERRAR
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Discomóvil Modal */}
      {isDiscomovilModalOpen && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl max-w-5xl w-full max-h-[90vh] overflow-y-auto border border-purple-400/30">
            <div className="p-8">
              {/* Header */}
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h2 className="text-4xl font-bold text-white tracking-wider mb-2">
                    DISCOMÓVILES
                  </h2>
                  <p className="text-purple-400 text-lg font-semibold">
                    ANIMACIÓN COMPLETA PARA TODAS LAS EDADES
                  </p>
                </div>
                <button
                  onClick={() => setIsDiscomovilModalOpen(false)}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>

              {/* Tipos de Discomóviles */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
                {/* Discomóvil Infantil */}
                <div className="bg-slate-700/50 rounded-xl p-6 border border-pink-400/20">
                  <div className="flex items-center mb-4">
                    <div className="bg-pink-400 w-12 h-12 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-bear-smile-line text-white text-xl"></i>
                    </div>
                    <h3 className="text-white text-xl font-bold">DISCOMÓVIL INFANTIL</h3>
                  </div>
                  <p className="text-gray-300 mb-4">
                    Diversión garantizada para los más pequeños.
                  </p>
                  <ul className="space-y-2 text-gray-300 text-sm">
                    <li className="flex items-center">
                      <i className="ri-check-line text-pink-400 mr-2"></i>
                      Música adaptada a todas las edades
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-pink-400 mr-2"></i>
                      Juegos y actividades dirigidas
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-pink-400 mr-2"></i>
                      Animador especializado
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-pink-400 mr-2"></i>
                      Luces de colores suaves
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-pink-400 mr-2"></i>
                      Material de animación incluido
                    </li>
                  </ul>
                </div>

                {/* Discomóvil Juvenil */}
                <div className="bg-slate-700/50 rounded-xl p-6 border border-cyan-400/20">
                  <div className="flex items-center mb-4">
                    <div className="bg-cyan-400 w-12 h-12 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-music-2-line text-black text-xl"></i>
                    </div>
                    <h3 className="text-white text-xl font-bold">DISCOMÓVIL JUVENIL</h3>
                  </div>
                  <p className="text-gray-300 mb-4">
                    La mejor música actual y tendencias del momento.
                  </p>
                  <ul className="space-y-2 text-gray-300 text-sm">
                    <li className="flex items-center">
                      <i className="ri-check-line text-cyan-400 mr-2"></i>
                      Hits actuales y música trending
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-cyan-400 mr-2"></i>
                      DJ especializado en público joven
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-cyan-400 mr-2"></i>
                      Efectos de luces LED dinámicas
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-cyan-400 mr-2"></i>
                      Máquina de humo y láser
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-cyan-400 mr-2"></i>
                      Solicitudes de música en directo
                    </li>
                  </ul>
                </div>

                {/* Discomóvil Adultos */}
                <div className="bg-slate-700/50 rounded-xl p-6 border border-yellow-400/20">
                  <div className="flex items-center mb-4">
                    <div className="bg-yellow-400 w-12 h-12 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-disc-line text-black text-xl"></i>
                    </div>
                    <h3 className="text-white text-xl font-bold">DISCOMÓVIL ADULTOS</h3>
                  </div>
                  <p className="text-gray-300 mb-4">
                    Música de todas las épocas para el público adulto.
                  </p>
                  <ul className="space-y-2 text-gray-300 text-sm">
                    <li className="flex items-center">
                      <i className="ri-check-line text-yellow-400 mr-2"></i>
                      Música de los 80, 90, 2000 y actual
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-yellow-400 mr-2"></i>
                      DJ con amplia experiencia
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-yellow-400 mr-2"></i>
                      Iluminación profesional elegante
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-yellow-400 mr-2"></i>
                      Música en vivo opcional
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-yellow-400 mr-2"></i>
                      Micrófono para dedicatorias
                    </li>
                  </ul>
                </div>

                {/* Discomóvil Premium */}
                <div className="bg-slate-700/50 rounded-xl p-6 border border-purple-400/20">
                  <div className="flex items-center mb-4">
                    <div className="bg-gradient-to-r from-purple-500 to-pink-500 w-12 h-12 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-vip-crown-line text-white text-xl"></i>
                    </div>
                    <h3 className="text-white text-xl font-bold">DISCOMÓVIL PREMIUM</h3>
                  </div>
                  <p className="text-gray-300 mb-4">
                    La experiencia más completa y exclusiva.
                  </p>
                  <ul className="space-y-2 text-gray-300 text-sm">
                    <li className="flex items-center">
                      <i className="ri-check-line text-purple-400 mr-2"></i>
                      DJ profesional + co-animador
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-purple-400 mr-2"></i>
                      Show de luces sincronizado
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-purple-400 mr-2"></i>
                      Efectos especiales (CO2, confeti)
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-purple-400 mr-2"></i>
                      Pantalla LED para videoclips
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-purple-400 mr-2"></i>
                      Cabina DJ personalizada
                    </li>
                  </ul>
                </div>
              </div>

              {/* Imagen y Características */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
                <div 
                  className="h-64 bg-cover bg-center rounded-xl"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=professional%20mobile%20disco%20DJ%20performing%20at%20party%2C%20colorful%20LED%20lights%2C%20people%20dancing%20happily%2C%20vibrant%20party%20atmosphere%2C%20modern%20DJ%20equipment%2C%20entertainment%20event&width=500&height=300&seq=55&orientation=landscape')`
                  }}
                >
                  <div className="h-full bg-gradient-to-t from-black/60 to-transparent rounded-xl flex items-end">
                    <div className="p-6">
                      <p className="text-white font-semibold text-lg">
                        "Animación que hace vibrar"
                      </p>
                    </div>
                  </div>
                </div>

                <div>
                  <h3 className="text-white text-2xl font-bold mb-4">
                    INCLUIDO EN TODOS LOS SERVICIOS
                  </h3>
                  <div className="space-y-4">
                    <div className="flex items-start space-x-3">
                      <i className="ri-truck-line text-purple-400 text-xl mt-1"></i>
                      <div>
                        <h4 className="text-white font-semibold">TRANSPORTE Y MONTAJE</h4>
                        <p className="text-gray-300 text-sm">Nos encargamos de todo el setup técnico</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <i className="ri-time-line text-purple-400 text-xl mt-1"></i>
                      <div>
                        <h4 className="text-white font-semibold">FLEXIBILIDAD HORARIA</h4>
                        <p className="text-gray-300 text-sm">Adaptamos horarios según tus necesidades</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <i className="ri-playlist-line text-purple-400 text-xl mt-1"></i>
                      <div>
                        <h4 className="text-white font-semibold">PLAYLIST PERSONALIZADA</h4>
                        <p className="text-gray-300 text-sm">Música seleccionada según el evento</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Botones de Acción */}
              <div className="flex flex-col sm:flex-row gap-4 pt-8 border-t border-slate-600">
                <button
                  onClick={() => {
                    setIsDiscomovilModalOpen(false);
                    setIsFormOpen(true);
                  }}
                  className="flex-1 bg-gradient-to-r from-purple-500 to-pink-600 text-white px-6 py-3 rounded-lg font-bold text-sm tracking-wider hover:scale-105 transition-transform duration-300 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-calendar-event-line mr-2"></i>
                  SOLICITAR PRESUPUESTO
                </button>
                <button
                  onClick={() => setIsDiscomovilModalOpen(false)}
                  className="px-6 py-3 border border-gray-500 text-gray-400 rounded-lg font-bold text-sm tracking-wider hover:border-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  CERRAR
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* DJProjecte Modal */}
      {isDjProjecteModalOpen && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto border border-cyan-400/30">
            <div className="p-8">
              {/* Header */}
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h2 className="text-4xl font-bold text-white tracking-wider font-mono mb-2">
                    DJ<br />PROJECTE
                  </h2>
                  <p className="text-cyan-400 text-lg font-semibold">
                    PROGRAMA DE CRECIMIENTO PROFESIONAL PARA NUEVOS DJS
                  </p>
                </div>
                <button
                  onClick={() => setIsDjProjecteModalOpen(false)}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>

              {/* Contenido Principal */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                {/* Descripción del Programa */}
                <div>
                  <div className="mb-8">
                    <h3 className="text-2xl font-bold text-white mb-4 tracking-wider">
                      ¿QUÉ ES DJ PROJECTE?
                    </h3>
                    <p className="text-gray-300 leading-relaxed mb-6">
                      Es un proyecto diseñado especialmente para ayudar a nuevos DJs que quieren comenzar a trabajar por su cuenta pero no cuentan con los recursos necesarios para empezar.
                    </p>
                    <p className="text-gray-300 leading-relaxed">
                      Nosotros te proporcionamos todo el soporte técnico, material y profesional que necesitas para crecer como DJ profesional.
                    </p>
                  </div>

                  <div className="space-y-6">
                    <div className="flex items-start space-x-4">
                      <div className="bg-cyan-400 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-music-2-line text-black text-lg"></i>
                      </div>
                      <div>
                        <h4 className="text-white font-bold text-lg mb-2">EQUIPAMIENTO PROFESIONAL</h4>
                        <p className="text-gray-300 text-sm">
                          Acceso a equipos de sonido profesionales, controladoras DJ, iluminación y todo el material necesario.
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-4">
                      <div className="bg-yellow-400 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-tools-line text-black text-lg"></i>
                      </div>
                      <div>
                        <h4 className="text-white font-bold text-lg mb-2">SOPORTE TÉCNICO</h4>
                        <p className="text-gray-300 text-sm">
                          Te enseñamos montaje, configuración y manejo profesional de equipos. No necesitas conocimiento técnico previo.
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-4">
                      <div className="bg-green-400 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-shield-check-line text-black text-lg"></i>
                      </div>
                      <div>
                        <h4 className="text-white font-bold text-lg mb-2">SEGURO INCLUIDO</h4>
                        <p className="text-gray-300 text-sm">
                          Cobertura completa de responsabilidad civil para que puedas trabajar con total tranquilidad.
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-4">
                      <div className="bg-purple-400 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-handshake-line text-black text-lg"></i>
                      </div>
                      <div>
                        <h4 className="text-white font-bold text-lg mb-2">GESTIÓN DE CONTRATOS</h4>
                        <p className="text-gray-300 text-sm">
                          Te ayudamos con la contratación con clientes, gestión comercial y administrativa.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Proceso y Beneficios */}
                <div>
                  <div 
                    className="h-48 bg-cover bg-center rounded-xl mb-8"
                    style={{
                      backgroundImage: `url('https://readdy.ai/api/search-image?query=young%20DJ%20learning%20with%20mentor%2C%20professional%20DJ%20equipment%20setup%2C%20training%20session%2C%20guidance%20and%20support%2C%20modern%20DJ%20controller%2C%20music%20production%20studio%2C%20professional%20development&width=500&height=300&seq=53&orientation=landscape')`
                    }}
                  >
                    <div className="h-full bg-gradient-to-t from-black/60 to-transparent rounded-xl flex items-end">
                      <div className="p-6">
                        <p className="text-white font-semibold text-lg">
                          "Tu crecimiento es nuestro objetivo"
                        </p>
                      </div>
                    </div>
                  </div>

                  <h3 className="text-2xl font-bold text-white mb-6 tracking-wider">
                    CÓMO FUNCIONA
                  </h3>

                  <div className="space-y-4">
                    <div className="flex items-center space-x-4 bg-slate-700/50 p-4 rounded-lg">
                      <div className="bg-cyan-400 w-8 h-8 rounded-full flex items-center justify-center text-black font-bold">
                        1
                      </div>
                      <div>
                        <h4 className="text-white font-semibold">EVALUACIÓN INICIAL</h4>
                        <p className="text-gray-300 text-sm">Conocemos tu nivel y objetivos</p>
                      </div>
                    </div>

                    <div className="flex items-center space-x-4 bg-slate-700/50 p-4 rounded-lg">
                      <div className="bg-yellow-400 w-8 h-8 rounded-full flex items-center justify-center text-black font-bold">
                        2
                      </div>
                      <div>
                        <h4 className="text-white font-semibold">FORMACIÓN TÉCNICA</h4>
                        <p className="text-gray-300 text-sm">Aprendes manejo y montaje profesional</p>
                      </div>
                    </div>

                    <div className="flex items-center space-x-4 bg-slate-700/50 p-4 rounded-lg">
                      <div className="bg-green-400 w-8 h-8 rounded-full flex items-center justify-center text-black font-bold">
                        3
                      </div>
                      <div>
                        <h4 className="text-white font-semibold">PRIMEROS EVENTOS</h4>
                        <p className="text-gray-300 text-sm">Te acompañamos en tus primeros trabajos</p>
                      </div>
                    </div>

                    <div className="flex items-center space-x-4 bg-slate-700/50 p-4 rounded-lg">
                      <div className="bg-purple-400 w-8 h-8 rounded-full flex items-center justify-center text-black font-bold">
                        4
                      </div>
                      <div>
                        <h4 className="text-white font-semibold">INDEPENDENCIA</h4>
                        <p className="text-gray-300 text-sm">Crecimiento progresivo hacia tu autonomía</p>
                      </div>
                    </div>
                  </div>

                  <div className="mt-8 p-6 bg-gradient-to-r from-cyan-500/20 to-purple-500/20 rounded-xl border border-cyan-400/30">
                    <h4 className="text-white font-bold text-lg mb-3">
                      <i className="ri-lightbulb-line text-yellow-400 mr-2"></i>
                      VENTAJAS DEL PROGRAMA
                    </h4>
                    <ul className="space-y-2 text-gray-300 text-sm">
                      <li className="flex items-center">
                        <i className="ri-check-line text-green-400 mr-2"></i>
                        Inversión inicial mínima
                      </li>
                      <li className="flex items-center">
                        <i className="ri-check-line text-green-400 mr-2"></i>
                        Formación continua y personalizada
                      </li>
                      <li className="flex items-center">
                        <i className="ri-check-line text-green-400 mr-2"></i>
                        Crecimiento a tu ritmo
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Botones de Acción */}
              <div className="flex flex-col sm:flex-row gap-4 pt-8 border-t border-slate-600 mt-8">
                <button
                  onClick={() => {
                    setIsDjProjecteModalOpen(false);
                    setIsFormOpen(true);
                  }}
                  className="flex-1 bg-gradient-to-r from-cyan-500 to-purple-600 text-white px-6 py-3 rounded-lg font-bold text-sm tracking-wider hover:scale-105 transition-transform duration-300 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-user-add-line mr-2"></i>
                  UNIRSE AL PROGRAMA
                </button>
                <button
                  onClick={() => setIsDjProjecteModalOpen(false)}
                  className="px-6 py-3 border border-gray-500 text-gray-400 rounded-lg font-bold text-sm tracking-wider hover:border-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  CERRAR
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventosPage;